import React from 'react';

function TermAndCondition() {
  return <div>
      <h1>Term and Condition</h1>
  </div>;
}

export default TermAndCondition;
